import React from "react";
import Arrow from "./icons/Arrow";
import { useNavigate } from "react-router-dom";
import s from "./style.module.scss";

interface GoBackProps {
  className?: string;
  black?: boolean;
  callback?: () => void;
}

const GoBack: React.FC<GoBackProps> = ({
  className = "",
  black = false,
  callback,
}) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    if (callback) {
      callback();
      return;
    }

    navigate(-1);
  };

  return (
    <div
      className={`${s.back} ${black ? s.black : ""} ${className}`}
      onClick={handleGoBack}
    >
      <Arrow />
    </div>
  );
};

export default GoBack;
